import {
    HTTP
} from '@/utilities/http-common';

import * as _ from 'lodash';

export default {
    namespaced: true,
    state: {
        user: {},
        myGroups: []
    },
    getters: {
        inMyGroups: (state) => (groups) => {
            return Boolean((_.intersection(state.myGroups, groups)).length);
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        getUser(state) {
            return state.user;
        },
        setMyGroups(state, groups) {
            state.myGroups = groups;
        }
    },
    actions: {
        setUser({
            commit
        }, user) {
            commit('setUser', user);
        },
        getUser() {
            return HTTP.get('/users/api/me/');
        },
        getMyGroups() {
            return HTTP.get('/users/api/user-groups/');
        },
        setMyGroups({ commit }, groups) {
            commit('setMyGroups', groups);
        }
    },
}